function counterAnimation(selector) {

    function counting(selector) {

        const counters = selector.querySelectorAll('.block-headingCounterNumbers .list-group-item > span');

        for (const counterContainer of counters) {
          const countNumbers = () => {
                const target = counterContainer.dataset.count;
                const numTarget = Number(target.replace(/\s+/g, ''));
                let count = Number(counterContainer.innerText);
                const interval = numTarget < 10 ? 500 : numTarget < 200 ? 5 : 1;
                let incrementVal = Math.floor(numTarget / 1000);
                const modulo = numTarget % 1000;

                if(numTarget === count){
                    counterContainer.innerText = target;
                    return;
                }

                let counterFunc = setInterval(function (){

                    if(modulo && numTarget - modulo <= count){
                        incrementVal = Math.ceil(modulo / 1000);
                    }

                    count = count + incrementVal;
                    counterContainer.innerText = Number(count);

                    if(numTarget === count){
                        clearInterval(counterFunc);
                        counterContainer.innerText = target;
                    }
                }, interval);
            }
            countNumbers();
        }
    }

    const elements = document.querySelectorAll(selector);

    if(elements.length>0){

        const fired = [...elements].map((element) => {
            return {
                element: element,
                fired: false,
            }
        });

        ['DOMContentLoaded', 'scroll'].forEach(event => {
            document.addEventListener(event, () => {
                elements.forEach((element, index) => {
                    const position = element.getBoundingClientRect();

                    if (position.top < window.innerHeight && position.bottom >= 0 && fired[index].fired === false) {
                        fired[index].fired = true;
                        counting(element);
                    }
                });
            });
        });

    }

}

//counterAnimation('.counter');
counterAnimation('.block-headingCounterNumbers');